// ==========================================
// Currency Conversion Utilities
// ==========================================

/**
 * Converts any currency amount to INR (Indian Rupee)
 * Backend always expects amounts in INR regardless of display currency
 *
 * @param {number} amount - The amount to convert
 * @param {object} currency - Currency object with code and exchangeRate
 * @returns {number} The amount converted to INR
 *
 * @example
 * // Convert USD to INR
 * const inrAmount = convertToINR(100, { code: 'USD', exchangeRate: 0.012 });
 * // Returns: 8333.33 (100 / 0.012)
 */
export const convertToINR = (amount, currency) => {
  if (!amount || currency.code === 'INR') return amount;
  // Convert from display currency to INR
  return parseFloat((amount / currency.exchangeRate).toFixed(2));
};

/**
 * Converts INR amount to any currency
 * Used for displaying backend INR values in selected currency
 *
 * @param {number} inrAmount - The amount in INR
 * @param {object} currency - Currency object with code and exchangeRate
 * @returns {number} The amount converted to target currency
 *
 * @example
 * // Convert INR to USD
 * const usdAmount = convertFromINR(1000, { code: 'USD', exchangeRate: 0.012 });
 * // Returns: 12 (1000 * 0.012)
 */
export const convertFromINR = (inrAmount, currency) => {
  if (!inrAmount || currency.code === 'INR') return inrAmount;
  // Convert from INR to display currency
  return parseFloat((inrAmount * currency.exchangeRate).toFixed(2));
};
